export default __webpack_public_path__ + "static/media/laptop_it.a3e3779e.png";